import { Ref, ref, getCurrentInstance, ComponentInternalInstance, computed } from '@vue/composition-api';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
type Handler = {
  getAid: (isNew: boolean, productid: string, extensionData: object) => Promise<void>;
  queryOrder: (purchaseId: string) => Promise<void>;
  openid: Ref<string>;
  pf: Ref<string>;
  aid: Ref<string>;
  successPay: Ref<boolean>;
  isGetCode: Ref<boolean>;
  purchaseOrgId: Ref<number | undefined>;
};
export default function handler(): Handler {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const orgId = computed(() => vm.$store.getters.orgId);
  const userId = computed(() => vm.$store.getters.userId);
  const openid = computed(() => `org_${orgId.value}_user_${userId.value}`); // 登陆态参数，默认取qq.com域下登录态中openid
  const aid = ref(''); // 订单id
  const billno = ref('');
  const pf = computed(() => `desktop_m_guest-pc-webpay-web-${aid.value}`);
  const successPay = ref(false); // 是否支付成功
  const isGetCode = ref(false);
  const purchaseOrgId = ref<number>();
  const methods = {
    async getAid(isNew: boolean, productid: string, extensionData: object) {
      try {
        const res = await smh.userAPI.midasPurchase({
          isNew,
          productid,
          extensionData,
        });
        aid.value = res.data.purchaseId;
        billno.value = aid.value;
        isGetCode.value = true;
      } catch (e) {
        tips.error(e as MsgError);
      }
    },
    // 查询订单状态
    async queryOrder(purchaseId: string) {
      try {
        const { data } = await smh.userAPI.midasGetPurchaseId({
          purchaseId,
        });
        successPay.value = data.completed;
        purchaseOrgId.value = data.purchaseOrgId;
      } catch (e: any) {
        if (Math.floor(e?.status / 100) === 5) {
          return;
        }
        tips.error(e as MsgError);
      }
    },
  };
  return {
    ...methods,
    aid,
    openid,
    pf,
    successPay,
    isGetCode,
    purchaseOrgId,
  };
}
